import { Card, CardContent } from '@mui/material'
import dayjs from 'dayjs'
import { flash } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../../contexts/objectContext/ObjectContext'
import { useMeteringType } from '../../contractInformation/hooks/trpcHooks'
import OverViewCard from './OverviewCard'

const MeteringTypeCard: React.FC = () => {
	const { t } = useTranslation('pages_overview')
	const { synerallId } = useContext(ObjectContext)
	const { data: meteringTypes } = useMeteringType(synerallId)

	if (!meteringTypes) return null

	const activeEnergyTypes = meteringTypes.filter(x => x.MeteringType === 'ActiveEnergy')

	return (
		<OverViewCard
			headerText={t('meteringTypeCard.electricMeter')}
			icon={flash}
			linkTarget='/exchange/price/day'
			className='stockprices'
		>
			<Card>
				<CardContent className='flex flex-col gap-2'>
					{activeEnergyTypes
						.sort((a, b) =>
							dayjs(a.ExistingDataFrom).isBefore(dayjs(b.ExistingDataFrom)) ? 1 : -1
						)
						.map((x, i) => (
							<div key={i} className='flex flex-col gap-1 text-sm'>
								<div>
									{t('meteringTypeCard.timeStep')}:{' '}
									{t(`meteringTypeCard.meteringTimeStep.${x.MeteringTimeStep}`)}
								</div>
								<div className='text-xs text-gray-500 dark:text-white'>
									{t('meteringTypeCard.dataAvailable')}:{' '}
									{dayjs(x.ExistingDataFrom).format('DD.MM.YYYY')} –{' '}
									{dayjs(x.ExistingDataTo).format('DD.MM.YYYY')}
								</div>
							</div>
						))}
				</CardContent>
			</Card>
		</OverViewCard>
	)
}

export default MeteringTypeCard
